import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const useTokenAutoLogout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkTokenValidity = () => {
      const token = sessionStorage.getItem('authToken');
      if (!token) return;

      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const now = Math.floor(Date.now() / 1000); 

        if (payload.exp < now) {
          sessionStorage.removeItem('authToken');
          navigate('/login', { replace: true });
        }
      } catch (e) {
        sessionStorage.removeItem('authToken');
        navigate('/login', { replace: true });
      }
    };

    checkTokenValidity();

    const intervalId = setInterval(checkTokenValidity, 30_000);

    return () => clearInterval(intervalId);
  }, []);
};

export default useTokenAutoLogout;